module.exports = __webpack_public_path__ + "img/feature1@2x.89ce5ea.png";